export default {"src":"/_next/static/media/checkmark.1f1fbe4d.svg","height":6,"width":7};